import React from 'react';
import MedicalRecord from './Medical_Record';
import '../../../CommonCSS/SocietyCSS.css'

const MedicalRecApp = () => {
  return (

    <div className="app-wrapper">
      <div className="form-container">
        <div className='card' style={{borderRadius: '8px'}}>
          <div className="card-header-css" style={{borderRadius: '8px', textAlign: 'center' }} >
            <h5>Student Medical Record</h5>
          </div>
        </div>
        <MedicalRecord />
      </div>
    </div >
  );
};

export default MedicalRecApp;
